import { CardTypes, IPaymentMethod } from 'features/payment/types';

import { IGetCheckoutPaymentMethodId } from '../types';

import { getValidPaymentMethodId } from './getValidPaymentMethodId';
import { getPreferredWalletOrder } from './utils';

/**
 * Checkout payment method can be a CC, prepaid card, Apple or Google Pay.
 *
 * When both wallets are available the platform-preferred one wins:
 * iOS -> Apple Pay, Android -> Google Pay, web -> Apple Pay (default).
 */
export const getCheckoutPaymentMethodId = ({
  paymentMethodHasBeenInit,
  accounts,
  usersPaymentMethodId,
  canUseApplePay,
  canUseGooglePay,
  applePayCardDetails,
  googlePayCardDetails,
}: IGetCheckoutPaymentMethodId) => {
  const checkoutAccounts = accounts;
  let userCheckoutPaymentMethodId = usersPaymentMethodId;

  const { first, second } = getPreferredWalletOrder();

  const walletMap: Record<string, { canUse: boolean; details: IPaymentMethod }> = {
    [CardTypes.APPLE_PAY]: { canUse: canUseApplePay, details: applePayCardDetails },
    [CardTypes.GOOGLE_PAY]: { canUse: canUseGooglePay, details: googlePayCardDetails },
  };

  // Process the less-preferred wallet first so the preferred one overwrites the selection
  for (const wallet of [second, first]) {
    const { canUse, details } = walletMap[wallet];
    if (canUse) {
      checkoutAccounts.unshift(details);
      if (!paymentMethodHasBeenInit) {
        userCheckoutPaymentMethodId = wallet;
      }
    }
  }

  // Return a valid checkout payment method
  return getValidPaymentMethodId({
    canUseApplePay,
    canUseGooglePay,
    paymentMethodId: userCheckoutPaymentMethodId,
    paymentMethods: checkoutAccounts,
  });
};
